/** Minimal nudge shape for library card + preview modal */
export type LibraryNudge = {
  id: string
  category: string
  title: string
  body: string
  channel: string
  system_target: string
  science_source: string | null
  effectiveness_score: number
}

export function normalizeLibraryNudge(row: Record<string, unknown>): LibraryNudge {
  const score = row.effectiveness_score
  const num = typeof score === 'number' ? score : Number(score)
  return {
    id: String(row.id ?? ''),
    category: String(row.category ?? ''),
    title: String(row.title ?? ''),
    body: String(row.body ?? ''),
    channel: String(row.channel ?? 'slack'),
    system_target: String(row.system_target ?? ''),
    science_source: row.science_source != null ? String(row.science_source) : null,
    effectiveness_score: Number.isFinite(num) ? num : 0,
  }
}
